import { render, staticRenderFns } from "./ServerStep.vue?vue&type=template&id=8aa70afc&"
import script from "./ServerStep.vue?vue&type=script&lang=ts&"
export * from "./ServerStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports